import React from "react";
import "./Contact.css";
import image6 from "../../../assets/6.jpg";
import image7 from "../../../assets/7.jpg";
import image8 from "../../../assets/8.webp";
import image9 from "../../../assets/image9.jpg";
import hassan from "../../../assets/hassan.jpg";
const Contact = () => {
  return (
    <div className="team-container">
      <h1>Project Developers</h1>
      <div className="team-cards">
        <div className="team-card">
          <img src={image7} alt="Hussein Sabry" className="team-image" />
          <h2>Hussein Sabry</h2>
          <p>
            <strong>Email:</strong> sabryhusseinhussein@gmail.com
          </p>
          <p>
            <strong>Phone:</strong> 01096586823
          </p>
          <p>
            <strong>Role:</strong> Backend Developer & Tester
          </p>
          <p>
            <a
              href="https://www.linkedin.com/in/hussein-sabry"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn Profile
            </a>
          </p>
        </div>
        <div className="team-card">
          <img src={image9} alt="Hussein Sabry" className="team-image" />
          <h2>Sayed Abdelwahed</h2>
          <p>
            <strong>Email:</strong> abdelwahedsayed1@gmail.com
          </p>
          <p>
            <strong>Role:</strong> Project idea owner
          </p>
          <p>
            <a
              href="www.linkedin.com/in/sayed-abdelwahed-9a5651315"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn Profile
            </a>
          </p>
        </div>
         <div className="team-card">
          <img src={hassan} alt="Hussein Sabry" className="team-image" />
          <h2>Hassan abdelwahed </h2>
         
          <p>
            <strong>Role:</strong> Frontend Developer 
          </p>
          <p>
            <a
              href="https://www.facebook.com/profile.php?id=61567668959097"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook Profile
            </a>
          </p>
        </div>
        <div className="team-card">
          <img src={image6} alt="Reda Abdelwahed" className="team-image" />
          <h2>Reda Abdelwahed</h2>
          <p>
            <strong>Role:</strong> UI & Frontend Developer
          </p>
          <p>
            <strong>Phone:</strong> +02 1044188791
          </p>
          <p>
            <strong>Email:</strong> redaalsnoty@gmail.com
          </p>
          <p>
            <a
              href="https://www.linkedin.com/in/reda-abdelwahed-77742033b/"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn Profile
            </a>
          </p>
        </div>

        <div className="team-card">
          <img src={image8} alt="Hussein Sabry" className="team-image" />
          <h2>Gehad Mohamed</h2>
          <p>
            <strong>Email:</strong> gehadmo157@gmail.com
          </p>
          <p>
            <strong>Role:</strong> Frontend Developer
          </p>
          <p>
            <a
              href="https://www.linkedin.com/in/gehad-mohamed-b19a41241"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn Profile
            </a>
          </p>
        </div>
       
       
      </div>
    </div>
  );
};

export default Contact;
